import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import "./CandidateFormView.css";
import CandidateFormHeader from "./CandidateFormHeader";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const CandidateFormView = () => {
  const [candidates, setCandidates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.dremerz.net/api/Project_17_ManPowerWebsite_Candidate_Aplication_Form"
        );
        setCandidates(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredData = candidates.filter((candidate) =>
    Object.values(candidate).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");
    XLSX.writeFile(workbook, "FilteredCandidates.xlsx");
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <CandidateFormHeader />
      <div className="CandidateAdmin-container">
        <div className="d-flex justify-content-around">
          <h2 className="text-center mb-4">Candidate Form</h2>

          <div className="dropdown">
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Select
            </button>

            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <a className="dropdown-item" href="/adminclientform">
                  Client Form
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="/admincandidateform">
                  Candidate Form
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="/admincontactus">
                  Enquiry Form
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="CandidateAdmin-search">
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <button className="btn btn-success" onClick={handleDownload}>
            Download Excel
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Action</th>
                <th>Age</th>
                <th>DOB</th>
                <th>Gender</th>
                <th>Father/Husband Name</th>
                <th>Address</th>
                <th>Aadhar No</th>
                <th>Caste/Religion</th>
                <th>Qualification</th>
                <th>Experience</th>
                <th>Type of Work</th>
                <th>Mode of Work</th>
                <th>Date of Joining</th>
                <th>Stay</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((candidate, index) => (
                  <tr key={index}>
                    <td>{candidate.name}</td>
                    <td>{candidate.mobile}</td>
                    <td>
                      <a
                        href={`https://wa.me/91${candidate.mobile}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaWhatsapp
                          size={20}
                          color="green"
                          style={{ marginRight: "8px" }}
                        />
                      </a>
                      <a href={`tel:+91${candidate.mobile}`}>
                        <FaPhoneAlt size={20} color="blue" />
                      </a>
                    </td>
                    <td>{candidate.age}</td>
                    <td>{candidate.dob}</td>
                    <td>{candidate.gender}</td>
                    <td>{candidate.fathername}</td>
                    <td>{candidate.address}</td>
                    <td>{candidate.aadhar}</td>
                    <td>{candidate.caste}</td>
                    <td>{candidate.qualification}</td>
                    <td>{candidate.experience}</td>
                    <td>{candidate.typeofwork}</td>
                    <td>{candidate.modeofwork}</td>
                    <td>{candidate.dateofjoining}</td>
                    <td>{candidate.stay}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="15" className="text-center">
                    No matching records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CandidateFormView;
